import React from "react";
import metaIcon from '../../../../../static/icons/hub/meta.svg';
import googleIcon from '../../../../../static/icons/hub/google.svg';
import tiktokIcon from '../../../../../static/icons/hub/tiktok.svg';
import amazonIcon from '../../../../../static/icons/hub/amazon.svg';

export const columns = [
    {
        title: 'Spend',
        dataIndex: 'spend',
        key: 'spend'
    },
    {
        title: 'CPP',
        dataIndex: 'cpp',
        key: 'cpp'
    },
    {
        title: 'Revenue',
        dataIndex: 'revenue',
        key: 'revenue'
    },
    {
        title: 'Orders',
        dataIndex: 'orders',
        key: 'orders'
    },
    {
        title: 'AOV',
        dataIndex: 'aov',
        key: 'aov'
    },
    {
        title: 'Profit',
        dataIndex: 'profit',
        key: 'profit'
    },
    {
        title: 'ROAS',
        dataIndex: 'roas',
        key: 'roas'
    },
    {
        title: 'Score',
        dataIndex: 'score',
        key: 'score'
    },
    {
        title: 'Sessions',
        dataIndex: 'sessions',
        key: 'sessions'
    },
    {
        title: 'Conversion%',
        dataIndex: 'conversion',
        key: 'conversion'
    },
    {
        title: 'ATOS',
        dataIndex: 'atos',
        key: 'atos'
    },
    {
        title: 'ATC_Conv.%',
        dataIndex: 'atc-conv',
        key: 'atc-conv'
    },
    {
        title: 'Items/Cust.',
        dataIndex: 'items-cust',
        key: 'items-cust'
    }
];

export const channels = [
    { label: 'Meta', value: 'Facebook', icon: <img src={metaIcon} width="24" height="24" /> },
    { label: 'Google', value: 'Google', icon: <img src={googleIcon} width="24" height="24" /> },
    { label: 'TikTok', value: 'TikTok', icon: <img src={tiktokIcon} width="24" height="24" /> },
    { label: 'Amazon Ads', value: 'Amazon Ads', icon: <img src={amazonIcon} width="24" height="24" /> }
];